module.exports = __webpack_public_path__ + "static/media/target.1bc8c768.png";